import { render } from "./ExtAuth.vue?vue&type=template&id=eca705fa"
import script from "./ExtAuth.vue?vue&type=script&lang=js"
export * from "./ExtAuth.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__